module.exports = __webpack_public_path__ + "assets/9a2de081ccd7838f2c67af8ac1432780.png";